import template from './_modal-select-operator.pug';

export default {
  template: template(),

  props: {
    operatorOptions: {
      type: Array,
      required: true
    },
    selectedTransports: {
      type: Object,
      required: true,
    },
    selectedOperators: {
      type: Object,
      required: true,
    },
    excludedTransports: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  data() {
    return {
      localSelectedOperator: {...this.selectedOperators},
      transportOperatorMap: {
        BUS: ['METROBUS', 'EMT', 'Metrobus'],
        SUBWAY: ['METROVALENCIA', 'Metro Valencia', 'Metro-Valencia', 'MetroValencia'],
        RAIL: ['RENFECERCANIAS', 'Renfe Cercanias', 'RENFE-Cercanias', 'RENFE-Cercanias QA'],
        BICYCLE_RENT: ['VALENBISI', 'Valenbisi'],
      }
    };
  },

  watch: {
    selectedOperators: {
      immediate: true,
      handler(newVal) {
        this.localSelectedOperator = {...newVal};
      }
    },
    selectedTransports: {
      deep: true,
      handler() {
        this.autoSelectOperators();
      }
    }
  },

  methods: {
    closeModal() {
      this.$emit('close');
    },

    applySelection() {
      this.$emit('update:selectedOperators', this.localSelectedOperator);
      this.$emit('applyOperator');
    },

    isOperatorDisabled(operator) {
      const relevantTransports = Object.keys(this.transportOperatorMap).filter(transport =>
        this.selectedTransports[transport]
      );

      if (relevantTransports.length === 0) {
        return false;
      }

      return !relevantTransports.some(transport =>
        this.transportOperatorMap[transport].includes(operator)
      );
    },

    autoSelectOperators() {
      const relevantTransports = Object.keys(this.transportOperatorMap).filter(transport =>
        this.selectedTransports[transport]
      );

      Object.keys(this.localSelectedOperator).forEach(operator => {
        this.$set(this.localSelectedOperator, operator, false);
      });

      relevantTransports.forEach(transport => {
        this.transportOperatorMap[transport].forEach(operator => {
          this.$set(this.localSelectedOperator, operator, true);
        });
      });
    }
  }
}
